import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import RestService from '../rest.service';
import LocalStorageService from '@components/collection/components/globals/backend-services/localStorage.service';
var REGISTER_URL = 'api/v1/customerfacing/customers/register?captchaVerified=true';
var INSTANTOR_INIT_URL = 'api/v1/customerfacing/customers/register/instantor/register';
var VALIDATE_URL = 'api/v1/customerfacing/customers/register/field/validateUnique';
var ACCOUNT_ACTIVATE_VIA_SMS_URL = 'api/v1/customerfacing/customers/smsVerification/account/activate';

var RegisterService = /*#__PURE__*/function () {
  function RegisterService() {
    _classCallCheck(this, RegisterService);
  }

  _createClass(RegisterService, [{
    key: "register",
    value: function register(data) {
      return new Promise(function (resolve, reject) {
        RestService.request(REGISTER_URL, {
          method: "POST",
          body: data
        }, true).then(function (data) {
          LocalStorageService.set('login-register-ones', 'true');
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "instantorRegister",
    value: function instantorRegister(data) {
      return new Promise(function (resolve, reject) {
        RestService.request(INSTANTOR_INIT_URL, {
          method: "POST",
          body: data
        }, true).then(function (data) {
          LocalStorageService.set('login-register-ones', 'true');
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "validateField",
    value: function validateField(field, value) {
      return new Promise(function (resolve, reject) {
        RestService.request("".concat(VALIDATE_URL, "?field=").concat(field, "&value=").concat(encodeURIComponent(value)), {
          method: "POST"
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }, {
    key: "activateAccountViaSMS",
    value: function activateAccountViaSMS(data) {
      return new Promise(function (resolve, reject) {
        RestService.request(ACCOUNT_ACTIVATE_VIA_SMS_URL, {
          method: "POST",
          body: data
        }, true).then(function (data) {
          resolve(data);
        }).catch(function (data) {
          reject(data);
        });
      });
    }
  }]);

  return RegisterService;
}();

export default new RegisterService();